import { ACTION_TYPES } from "../../../constants/index";

export const setExpiryItems = (items) => ({
  type: ACTION_TYPES.SET_EXPIRY_ITEMS,
  payload: items,
});

export const clearExpiryItems = () => ({
  type: ACTION_TYPES.CLEAR_EXPIRY_ITEMS,
});
